import $ from 'jquery';
import {smoothy} from "../Libraries/smoothy";

let noScroll = false;
// in case we got "radio" buttons, this piece of js allows
// unchecking of an activated radio button. Every other
// behaviour is done in CSS.
$(document.body).on('click', '.accordion--radio .accordion__header', function (ev) {
    const $parent = $(this).closest('.accordion__element');
    const $check = $parent.find('.accordion__check');
    if ($check.prop('checked')) {
        $check.prop('checked', false);
        ev.preventDefault();
    } else if (!noScroll) {
        smoothy(() => $parent.offset().top, 500);
        window.history.pushState({}, '', '#' + $parent.attr('id'));
    }
});


let hash = location.hash;
if (hash.substring(0,1) === '#') {
    hash = hash.substring(1);
}

if (hash.indexOf('accordion-element-') === 0) {
    noScroll = true;
    let $target = $('#' + hash);
    if ($target.length === 0) {
        $target = $('[data-backup-id="' + hash + '"]');
    }
    if ($target.length) {
        $target.find('.accordion__header').trigger('click');
    }
    noScroll = false;
}
